export default "__VITE_ASSET__DUrgz35w__"